import React from 'react';
import { useTranslation } from 'react-i18next';

const Loader = () => {
  const { t } = useTranslation();

  return (
    <div className='d-flex justify-content-center u-mt-2 u-mb-2'>
      <div className='spinner-border u-color-primary' role='status'>
        <span className='visually-hidden'>{t('LOADING')}</span>
      </div>
    </div>
  )
};

export default Loader
